import React, { useState } from 'react'
import LoaderAdvanced from 'react-loader-advanced'
import { compose } from 'redux'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
// lib
import Grid from '@material-ui/core/Grid/index'
import withStyles from '@material-ui/core/styles/withStyles'
import CircularProgress from '@material-ui/core/CircularProgress'
import { getStyles } from 'isotope-client'
// api
import { getSyntheseDatas } from '../services/api'
import { getSyntheseResultatDatas } from '../services/resultatApi'
// components
import PlanificationVsCharge from './synthese/PlanificationVsCharge'
import { useGestionTacheContext } from '../GestionTacheProvider'
import SchedulerPage from '../../scheduler/SchedulerPage'
import Button from '../../../../components/Button'
// consts
import { ELEMENTS_TO_DISPLAY } from '../../scheduler/services/schedule.consts'

const styles = (theme) => getStyles({
	withBorder: {
		border: '0.5px solid lightgray'
	},
	link: {
		color: theme.palette.primary.main,
		textTransform: 'none'
	}
})

const DebugOnglet = ({ classes }) => {
	const [datas, setDatas] = useState(undefined)
	const [loading, setLoading] = useState(false)
	const { isResultat } = useGestionTacheContext()
	const [showScheduler, setShowScheduler] = useState(false)
	const [toolsOrCompetences, setToolsOrCompetences] = useState(ELEMENTS_TO_DISPLAY.TOOLS)

	React.useEffect(() => {
		setLoading(true)
		const promise = isResultat ? getSyntheseResultatDatas(true) : getSyntheseDatas(true)
		promise.then(setDatas).finally(() => setLoading(false))
	}, [isResultat])

	return (
		<LoaderAdvanced
			show={!datas || loading}
			message={<CircularProgress />}
			backgroundStyle={{ backgroundColor: 'rgba(255,255,255,0.5)' }}
		>
			<Grid>
				<Grid>
					<Button
						type="primary"
						onClick={() => {
							setToolsOrCompetences(ELEMENTS_TO_DISPLAY.TOOLS)
							setShowScheduler(true)
						}}>
						<FormattedMessage id="gestionTaches.debug.calendrierTools" />
					</Button>
				</Grid>
				<Grid container item direction="column" style={{ padding: '1%', gap: 20 }}>
					<Grid container item className={classes.withBorder}>
						{datas && <PlanificationVsCharge datas={datas.planificationVsCharge} isDays />}
					</Grid>
				</Grid>
				<SchedulerPage
					open={showScheduler}
					isResultat={isResultat}
					handleClose={() => setShowScheduler(false)}
					ressourcesToDisplay={toolsOrCompetences}
				/>
			</Grid>
		</LoaderAdvanced>
	)
}

DebugOnglet.propTypes = {
	classes: PropTypes.object
}

export default compose(
	withStyles(styles)
)(DebugOnglet)